<template>
  <div class="product-page page">
    <BreadcrumbsComponent @back.prevent :links="links" />
    <div class="product-page__container sides-padding">
      <div class="container">
        <div class="product-page__content">
          <h1 class="product-page__title">{{ data.title }}</h1>
          <div class="product-page__body">
            <div class="product-page__left">
              <ProductGalleryComponent
                :items="active_set.images && active_set.images.length ? active_set.images : data.images"
                :head_img="data.head_img"
                class="product-page__gallery"
              />
              <div class="product-page__description">
                <EditorJSComponent v-if="data.description" :text="data.description" />
              </div>
              <div v-if="data.brand && data.brand.description" class="product-page__brand-description">
                <h4>О бренде</h4>
                <EditorJSComponent :text="data.brand.description" />
              </div>
              <div class="product-page__reviews">
                <ReviewsComponent
                  id="reviews"
                  :reviews="data.reviews"
                  :data="data"
                  reviewable_type="App\Models\ProductItem"
                />
              </div>
            </div>
            <div class="product-page__right">
              <ProductGalleryComponent
                :items="active_set.images && active_set.images.length ? active_set.images : data.images"
                :head_img="data.head_img"
                class="product-page__gallery"
              />
              <div class="product-page__tags">
                <span
                  class="product-page__tag product-page__tag--discount"
                  v-if="data.join_share && data.join_share.share"
                >
                  -{{ data.join_share.share.percent }}%
                </span>
                <span
                  class="product-page__tag product-page__tag--sell"
                  v-if="data.join_share && data.join_share.share"
                >
                  распродажа
                </span>
                <span class="product-page__tag product-page__tag--new" v-if="isProductNew(data.created_at)">
                  новинка
                </span>
                <span class="product-page__tag product-page__tag--hit" v-if="data.in_popular">хит</span>
                <div class="product-page__reviews-count">
                  <ReviewStarsComponent :mark="averageReviewsMark" />
                  <router-link :to="{ hash: '#reviews' }">
                    {{ data.reviews.length }}
                    {{ data.reviews.length | plural_word("отзыв", "отзыва", "отзывов") }}
                  </router-link>
                </div>
              </div>
              <div class="product-page__prices">
                <span
                  v-if="(active_set.join_share && active_set.join_share.share) || (data.join_share && data.join_share.share)"
                  class="product-page__old-price"
                >
                  {{ active_set.price | formatPrice }}
                </span>
                <span class="product-page__price">
                  {{ active_set.price | share_price(active_set.join_share ? active_set : data) | formatPrice }}
                </span>
                <span v-if="!available" class="product-page__not-available">Нет в наличии</span>
              </div>
              <div v-if="data.product_sets && data.product_sets.length" class="product-page__params">
                <template v-for="(key, index) in Object.keys(attributes)">
                  <div :key="index" class="product-page__param" v-if="attributes[key].values.length">
                    <span class="product-page__param-title">{{ attributes[key].title }}:</span>
                    <div class="product-page__param-values">
                      <label
                        v-for="(item, i) in attributes[key].values"
                        :key="i"
                        class="product-page__param-value"
                        :class="{
                          'product-page__param-value--active': isAttributeChecked(key, item),
                          'product-page__param-value--disable': isAttributeDisable(key, item),
                        }"
                      >
                        <input
                          type="checkbox"
                          v-show="false"
                          :checked="isAttributeChecked(key, item)"
                          @change="changeSet(key, item)"
                        />
                        <span class="product__attribute-title">{{ item.value }}</span>
                      </label>
                    </div>
                  </div>
                </template>
              </div>
              <div v-if="available" class="product-page__buy">
                <button
                  @click="cartAdd"
                  :class="{ 'btn--main': !inCart, 'btn--dark-light': inCart }"
                  class="btn btn--lg"
                  type="button"
                >
                  <IconComponent name="bag-2" />
                  <span v-if="!inCart">В корзину</span>
                  <span v-else>В корзине</span>
                </button>
                <div class="product-page__count">
                  <button @click="count = count - 1 || 1" class="product-page__count-change btn btn--lg">
                    <IconComponent name="minus" />
                  </button>
                  <input @input="countInput" v-model="count" class="product-page__count-value" type="text" />
                  <button @click="count += 1" class="product-page__count-change btn btn--lg">
                    <IconComponent name="add" />
                  </button>
                </div>
              </div>
              <div class="product-page__actions">
                <a
                  @click.prevent="addToFavorites"
                  :class="{ 'product-page__action--active': inFavorites }"
                  class="product-page__action btn"
                >
                  <IconComponent name="heart" />
                  <span>{{ inFavorites ? "В списке желаний" : "Добавить в список желаний" }}</span>
                </a>
                <a @click.prevent class="product-page__share" href="#">
                  <span class="product-page__action btn">
                    <IconComponent name="share-2" />
                    <span>Поделиться</span>
                  </span>
                  <ShareNetworksComponent class="product-page__share-networks" :data="data" isProduct />
                </a>
              </div>
              <div v-if="data.brand" class="product-page__brand">
                <ImgComponent
                  :head_img="data.brand.head_img"
                  height="100"
                  width="300"
                  class="product-page__brand-img"
                  contain
                />
                <div class="product-page__brand-title">
                  <span>Бренд</span>
                  <span class="product-page__brand-name">{{ data.brand.title }}</span>
                </div>
                <router-link
                  :to="{ name: 'catalog', query: { brand_id: data.brand.id, page_title: data.brand.title } }"
                  class="btn btn--sm btn--main btn--with-icon"
                >
                  <span>Все товары бренда</span>
                  <IconComponent name="arrow-right-1" />
                </router-link>
              </div>
              <ul class="product-page__props">
                <li v-if="active_set.articul" class="product-page__prop">
                  <span class="product-page__prop-title">Артикул:</span>
                  <span class="product-page__prop-line"></span>
                  <span class="product-page__prop-value">{{ active_set.articul }}</span>
                </li>
                <li v-if="active_set.weight" class="product-page__prop">
                  <span class="product-page__prop-title">Вес с упаковкой (кг.):</span>
                  <span class="product-page__prop-line"></span>
                  <span class="product-page__prop-value">{{ active_set.weight }}</span>
                </li>
                <li v-if="active_set.volume" class="product-page__prop">
                  <span class="product-page__prop-title">Объём упаковки (м3):</span>
                  <span class="product-page__prop-line"></span>
                  <span class="product-page__prop-value">{{ active_set.volume }}</span>
                </li>
                <li v-if="data.brand && data.brand.title" class="product-page__prop">
                  <span class="product-page__prop-title">Бренд:</span>
                  <span class="product-page__prop-line"></span>
                  <span class="product-page__prop-value">{{ data.brand.title }}</span>
                </li>
                <li v-if="data.country && data.country.title" class="product-page__prop">
                  <span class="product-page__prop-title">Страна-производитель:</span>
                  <span class="product-page__prop-line"></span>
                  <span class="product-page__prop-value">{{ data.country.title }}</span>
                </li>
                <li v-if="compositionsString" class="product-page__prop">
                  <span class="product-page__prop-title"> Состав: </span>
                  <span class="product-page__prop-line"></span>
                  <span class="product-page__prop-value"> {{ compositionsString }} </span>
                </li>
                <li v-for="(item, i) in attributeValuesModified" :key="i" class="product-page__prop">
                  <span class="product-page__prop-title" v-if="item[0] && item[0].attribute">
                    {{ item[0].attribute.title }}:
                  </span>
                  <span class="product-page__prop-line"></span>
                  <span class="product-page__prop-value">{{ getAttributesString(item) }}</span>
                </li>
              </ul>
              <!--              <ul class="product-page__specs">-->
              <!--                <li v-for="(item, i) in specs" :key="i" class="product-page__spec">-->
              <!--                  <span class="product-page__spec-icon">-->
              <!--                    <IconComponent :name="item.icon" />-->
              <!--                  </span>-->
              <!--                  <div class="product-page__spec-info">-->
              <!--                    <span class="product-page__spec-title">{{ item.title }}</span>-->
              <!--                    <span class="product-page__spec-description">{{ item.description }}</span>-->
              <!--                  </div>-->
              <!--                </li>-->
              <!--              </ul>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <ProductsComponent title="С этим товаром покупают" :list="data.recommend_products" />
    <ProductsComponent title="Похожие товары" :list="data.similar_products" />
    <ProductsComponent title="Не забудьте купить" :list="data.brand_products" />
  </div>
</template>

<script>
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";
import ProductGalleryComponent from "components/product/ProductGalleryComponent.vue";
import EditorJSComponent from "components/EditorJSComponent.vue";
import ReviewsComponent from "components/reviews/ReviewsComponent.vue";
import ReviewStarsComponent from "components/reviews/ReviewStarsComponent.vue";
import LoginModal from "components/modals/components/LoginModal.vue";
import IconComponent from "components/IconComponent.vue";
import ProductsComponent from "./components/ProductsComponent.vue";
import PRODUCT_PAGE from "@/graphql/pages/ProductPage.graphql";
import ShareNetworksComponent from "components/ShareNetworksComponent.vue";

export default {
  name: "ProductPage",
  async asyncData({ apollo, store, route }) {
    await apollo.defaultClient
      .query({
        query: PRODUCT_PAGE,
        variables: {
          id: parseInt(route.params.id),
        },
      })
      .then(({ data }) => {
        store.state.product_page.product = data.product;
        store.state.all_brands = data.brands || [];
        store.state.popular_brands = data.brands_paginate.data || [];
        store.state.categories = data.header_categories.data || [];
        store.state.pages = data.pages;
        store.state.marketplace = data.marketplace;
      });
  },
  data() {
    return {
      loading: false,
      active_set: null,
      count: 1,
      attributes: {
        variation_one: {
          id: null, // id атрибута
          title: null, // заголовок атрибута
          values: [], // значения атрибута
        },
        variation_two: {
          id: null,
          title: null,
          values: [],
        },
        variation_three: {
          id: null,
          title: null,
          values: [],
        },
      },
      selected_attribute_values: {
        variation_one: null,
        variation_two: null,
        variation_three: null,
      },
    };
  },
  watch: {
    // выбранные значения атрибутов, на основании них находим соответствующую вариацию, если она есть
    selected_attribute_values: {
      handler() {
        const hasSelection =
          this.selected_attribute_values.variation_one ||
          this.selected_attribute_values.variation_two ||
          this.selected_attribute_values.variation_three;
        if (!hasSelection) {
          this.active_set = this.data;
          return;
        }
        this.active_set =
          this.data.product_sets.find(
            (item) =>
              item.variation_one?.value.id === this.selected_attribute_values.variation_one?.id &&
              item.variation_two?.value.id === this.selected_attribute_values.variation_two?.id &&
              item.variation_three?.value.id === this.selected_attribute_values.variation_three?.id
          ) || this.data;
      },
      deep: true,
    },
  },
  created() {
    // по умолчанию активной вариацией является родительский товар
    this.active_set = this.data;
    if (this.data.product_sets && this.data.product_sets.length) {
      // берем названия и id атрибутов первой вариации, например цвет, размер
      if (this.data.product_sets[0].variation_one && this.data.product_sets[0].variation_one.attribute) {
        this.attributes.variation_one.title = this.data.product_sets[0].variation_one.attribute.title;
        this.attributes.variation_one.id = this.data.product_sets[0].variation_one.attribute.id;
      }
      if (this.data.product_sets[0].variation_two && this.data.product_sets[0].variation_two.attribute) {
        this.attributes.variation_two.title = this.data.product_sets[0].variation_two.attribute.title;
        this.attributes.variation_two.id = this.data.product_sets[0].variation_two.attribute.id;
      }
      if (this.data.product_sets[0].variation_three && this.data.product_sets[0].variation_three.attribute) {
        this.attributes.variation_three.title = this.data.product_sets[0].variation_three.attribute.title;
        this.attributes.variation_three.id = this.data.product_sets[0].variation_three.attribute.id;
      }
      // проходимся по вариациям и собираем все значения атрибутов для каждого атрибута variation_...
      this.data.product_sets.forEach((item) => {
        if (
          item.variation_one &&
          item.variation_one.value &&
          !this.attributes.variation_one.values.find((v) => v.id === item.variation_one.value.id)
        ) {
          this.attributes.variation_one.values.push(item.variation_one.value);
        }
        if (
          item.variation_two &&
          item.variation_two.value &&
          !this.attributes.variation_two.values.find((v) => v.id === item.variation_two.value.id)
        ) {
          this.attributes.variation_two.values.push(item.variation_two.value);
        }
        if (
          item.variation_three &&
          item.variation_three.value &&
          !this.attributes.variation_three.values.find((v) => v.id === item.variation_three.value.id)
        ) {
          this.attributes.variation_three.values.push(item.variation_three.value);
        }
      });

      // если перешли по вариации продукта, то выбираем ее активной
      let set = this.data.product_sets.find((set) => set.id === parseInt(this.$route.query.set_id));
      if (set) {
        this.selected_attribute_values.variation_one = set.variation_one?.value;
        this.selected_attribute_values.variation_two = set.variation_two?.value;
        this.selected_attribute_values.variation_three = set.variation_three?.value;
      } else {
        const hasAnyVariation =
          this.attributes.variation_one.values.length ||
          this.attributes.variation_two.values.length ||
          this.attributes.variation_three.values.length;
        if (hasAnyVariation) {
          this.selected_attribute_values.variation_one = this.attributes.variation_one.values[0];
        } else {
          this.active_set = this.data.product_sets[0];
        }
      }
    }
  },
  computed: {
    data() {
      return this.$store.state.product_page.product;
    },
    inCart() {
      return this.active_set && !!this.$store.state.auth.cart.find((c) => c.item?.id === this.active_set?.id);
    },
    available() {
      return this.data.availability && this.active_set.availability;
    },
    links() {
      let links = [];
      if (this.data.category) {
        let category = this.data.category;
        while (category) {
          links.unshift({
            title: category.title,
            route: {
              name: "catalog",
              params: { id: category.id },
            },
          });
          category = category.parent;
        }
      }
      links.push({ title: this.data.title });
      return links;
    },
    // составляющие продукта (материалы)
    compositions() {
      return this.$store.state.product_page.product?.compositions;
    },
    // состав в виде строки
    compositionsString() {
      if (this.compositions && this.compositions.length) {
        return this.compositions
          .filter((c) => c.composition)
          .map((i) => `${i.percent}% ${i.composition.title}`)
          .join(", ");
      }
      return null;
    },
    // характеристики товара, сгруппированные
    attributeValuesModified() {
      let map = {};
      this.data.attribute_values.forEach((i) => {
        map[i.attribute.id] = map[i.attribute.id] || [];
        map[i.attribute.id].push(i);
      });
      return Object.values(map);
    },
    // средняя оценка продукта
    averageReviewsMark() {
      if (this.data && this.data.reviews && this.data.reviews.length) {
        let length = this.data.reviews.length;
        return Math.floor(this.data.reviews.map((r) => parseInt(r.mark)).reduce((a, b) => a + b, 0) / length);
      }
      return 0;
    },
    inFavorites() {
      return this.$store.state.auth.favorites.find((k) => k.item.id === this.data.id);
    },
    isRegistered() {
      return !!this.$store.state.apollo_token || this.$store.state.auth.user;
    },
    needVariationSelect() {
      if (this.data.product_sets && this.data.product_sets.length) {
        return !this.data.product_sets.find((item) => item.id === this.active_set.id);
      }
      return false;
    },
  },
  methods: {
    item_img(data) {
      let image = this.$options.filters.item_img(data);
      return image ? image.path : null;
    },
    // добавление в корзину
    cartAdd() {
      // если вариации есть, но ни одна не выбрана
      if (this.needVariationSelect) {
        this.$notify({
          title: "Внимание",
          text: "Выберите, пожалуйста, модель товара",
          duration: 3000,
          speed: 200,
          type: "warn",
        });
      } else {
        // если такого товара нет в корзине, то добавляем
        if (!this.inCart) {
          this.$store.state.auth.cart.unshift({
            count: this.count,
            item: this.active_set,
          });
        } else {
          this.$router.push({ name: "cart" }).then(() => {
            this.$emit("close");
          });
        }
        if (this.isRegistered && !this.loading) {
          this.$store
            .dispatch("CART_ADD_ITEMS", {
              apollo: this.$apollo,
              variables: {
                items: [
                  {
                    id: this.active_set.id,
                    count: this.count,
                  },
                ],
              },
            })
            .then(() => {
              this.loading = false;
            })
            .catch((error) => {
              this.loading = false;
              console.error(error);
            });
        }
      }
    },
    async addToFavorites() {
      if (this.isRegistered) {
        let index = this.$store.state.auth.favorites.findIndex((k) => k.item.id === this.data.id);
        if (index !== -1) {
          this.$store.state.auth.favorites.splice(index, 1);
        } else {
          this.$store.state.auth.favorites.push({ item: this.data });
        }
        await this.$store.dispatch("FAVORITE_CREATE_OR_DELETE", {
          apollo: this.$apollo,
          variables: {
            item_id: this.data.id,
          },
        });
      } else {
        this.showLoginModal();
      }
    },
    changeSet(variation, val) {
      if (
        this.selected_attribute_values[variation] &&
        this.selected_attribute_values[variation].id === val.id
      ) {
        this.selected_attribute_values[variation] = null;
      } else {
        this.selected_attribute_values[variation] = val;
      }
    },
    isAttributeChecked(variation, val) {
      if (this.selected_attribute_values[variation]) {
        return this.selected_attribute_values[variation].id === val.id;
      }
      return false;
    },
    isAttributeDisable(variation, val) {
      let selected_attribute_values = JSON.parse(JSON.stringify(this.selected_attribute_values));
      selected_attribute_values[variation] = val;

      let sets = this.data.product_sets;
      if (selected_attribute_values.variation_one) {
        sets = sets.filter(
          (item) =>
            item.variation_one && item.variation_one.value.id === selected_attribute_values.variation_one.id
        );
      }
      if (selected_attribute_values.variation_two) {
        sets = sets.filter(
          (item) =>
            item.variation_two && item.variation_two.value.id === selected_attribute_values.variation_two.id
        );
      }
      if (selected_attribute_values.variation_three) {
        sets = sets.filter(
          (item) =>
            item.variation_three &&
            item.variation_three.value.id === selected_attribute_values.variation_three.id
        );
      }
      return !sets.length;
    },
    getAttributesString(arr) {
      if (arr && arr.length) {
        return arr.map((i) => i.value?.value).join(", ");
      }
      return null;
    },
    showLoginModal() {
      this.$store.state._modals.push({
        component: LoginModal,
        options: {},
      });
    },
    countInput(e) {
      let count = parseInt(e.target.value.replace(/[^0-9]/g, ""));
      this.count = count && count > 1 ? count : 1;
    },
    isProductNew(date) {
      let oneDay = 1000 * 60 * 60 * 24;
      return date ? Math.floor((Date.now() - new Date(date).getTime()) / oneDay) <= 14 : false;
    },
  },
  components: {
    ShareNetworksComponent,
    ProductsComponent,
    IconComponent,
    ReviewsComponent,
    ReviewStarsComponent,
    EditorJSComponent,
    ProductGalleryComponent,
    BreadcrumbsComponent,
  },
  metaInfo() {
    return {
      title: this.data.meta_title || this.data.title,
      description: this.data.meta_description,
      keywords: this.data.meta_keywords,
      meta: [
        {
          vmid: "og:image",
          name: "og:image",
          property: "og:image",
          content: this.data.head_img
            ? this.$store.state._env.MEDIA_ENDPOINT + this.item_img(this.data)
            : null,
        },
      ],
    };
  },
};
</script>

<style lang="stylus">
.product-page {
  display grid
  grid-gap 50px
  padding 32px 0 48px
  +below(680px) {
    grid-gap 30px
  }

  &__container {
    display flex
    align-items center
  }

  &__title {
    font-size 1.5em
    text-align left
    +below(680px) {
      font-size 1.25em
    }
    +below(480px) {
      font-size 1.125em
    }
  }

  &__body {
    display grid
    grid-template-columns 746fr 524fr
    grid-gap 30px
    align-items start
    +below(1100px) {
      display flex
      flex-direction column-reverse
    }
  }

  &__left {
    .product-gallery {
      +below(1100px) {
        display none
      }
    }
  }

  &__description {
    margin-top: 50px;
    +below(1100px) {
      margin-top 0
    }
  }

  &__brand-description {
    margin-top: 20px;
  }

  &__reviews {
    margin-top: 38px;
  }

  &__right {
    display flex
    flex-direction column
    gap 20px
    +above(1101px) {
      position sticky
      top 30px
    }
    +below(1100px) {
      width 100%
    }

    .product-gallery {
      +above(1101px) {
        display none
      }
    }
  }

  &__tags {
    display flex
    align-items center
    flex-wrap wrap-reverse
    gap 5px
    font-size: 0.875em
    line-height: 16px;
  }

  &__tag {
    padding 3px 7px
    border-radius: var(--small_radius)
    color var(--white)

    &--new {
      background var(--green)
    }

    &--discount {
      font-weight 700
      background var(--yellow)
      color: var(--main-color)
    }

    &--hit {
      background var(--purple)
    }

    &--sell {
      background var(--red)
    }
  }

  &__reviews-count {
    margin-left auto
    text-decoration-line: underline;
    color: var(--main-color)
    display flex
    align-items center
    gap 10px
  }

  &__prices {
    display flex
		flex-wrap: wrap;
    align-items center
    gap 5px 20px
  }

  &__old-price {
    font-weight: 700;
    font-size: 1.375em
    line-height: 115%
    color: var(--main-color-75)
    text-decoration line-through
    text-decoration-color var(--main-color)
  }

	&__not-available,
  &__price {
    font-weight: 700;
    font-size: 2.125em
    line-height: 115%
    color: var(--main-color)
  }

	&__not-available {
		font-size 2rem
		color: var(--body-color)
		margin-left auto
		+below(1200px) {
			margin-left 0
			width 100%
		}
	}

  &__params {
    display flex
    flex-direction column
    gap 10px
  }

  &__param {
    display flex
    flex-direction column
    gap 5px

    &-title {
      font-size: 0.875em
      line-height: 145%;

      span {
        color var(--main-color-75)
      }
    }

    &-values {
      display flex
      align-items center
      gap 5px
    }

    &-value {
      padding 8px
      border: 2px solid var(--gray-2-dark);
      border-radius var(--small_radius)
      cursor pointer
      min-width 44px
      display flex
      justify-content center
      transition var(--transition)

      &:not(&--disable):hover {
        border-color var(--black_o5)
      }

      &--active {
        border-color var(--main-color)
      }

      &--disable {
        background var(--main-color-75)
        background var(--gray_d10)
        opacity .9
        pointer-events none
      }

      input {
        position absolute
        visibility hidden
      }
    }
  }

  &__buy {
    display flex
    align-items center
    gap 20px
    +below(480px) {
      flex-direction column
      align-items stretch
      gap 15px
    }
  }

  &__count {
    display flex
    align-items center
    justify-content center
    border 1px solid transparent
    border-radius: var(--big_radius)
    overflow hidden

    * {
      width 60px
      height 60px
      display flex
      align-items center
      justify-content center
    }

    &-change {
      transition var(--transition)
      border-radius 0
      background var(--gray)

      &:hover {
        background var(--main-color-75)
      }

      .icon {
        width 20px
        height 20px
      }
    }

    &-value {
      font-size 1.125em
      border: 1px solid var(--gray);
      overflow hidden
      text-align center
      padding 10px
      +below(480px) {
        flex-grow 1
      }
    }
  }

  &__actions {
    display flex
    flex-wrap wrap
    align-items center
    gap 20px
    +below(440px) {
      gap 10px
      flex-direction column
      align-items flex-start
    }
  }

  &__action {
    display flex
    align-items center
    gap 5px
    text-transform none
    font-size: 1em
    line-height: 170%;

    &--active {
      svg path {
        fill var(--main-color)
        stroke var(--main-color)
      }
    }

    svg {
      width 20px
      height 20px

      path {
        transition var(--transtition)
      }
    }
  }

  &__share {
    position relative

    &:hover {
      .product-page__share-networks {
        opacity 1
        visibility visible
      }
    }

    &-networks {
      opacity 0
      visibility hidden
      transition var(--transition)
      position absolute
      top calc(100% + 5px)
      left 0
      padding 15px 10px 10px
      border-radius var(--main_radius)
      box-shadow: 0 4px 16px 1px rgba(0,26,52,.16);
      z-index 5
      background var(--white)
      width auto
      +above(441px) {
        left: 50%;
        transform: translateX(-50%);
      }

      &::after {
        content ""
        display block
        background var(--white)
        width 10px
        height: 10px
        position absolute
        z-index 4
        top: 0
        left 50%
        transform translate(-50%, -50%) rotate(45deg)
      }
    }
  }

  &__brand {
    padding 10px
    border: 1px solid var(--gray);
    border-radius: var(--main_radius)
    display flex
    align-items center
    gap 15px
    +below(420px) {
      flex-wrap wrap
      justify-content center
    }

    &-img {
      height 50px
      width auto
    }

    &-title {
      display flex
      flex-direction column
      font-size: 0.875em
      line-height: 145%;
    }

    &-name {
      font-weight: 700;
      font-size: 1em;
      line-height: 145%;
    }

    .btn {
      margin-left auto
      text-transform none
      font-weight: 700;
      +below(420px) {
        margin 0
      }

      .icon {
        width 12px
        height 12px
      }
    }
  }

  &__props {
    display grid
    grid-gap 10px
  }

  &__prop {
    display grid
    grid-template-columns auto minmax(10px, 1fr) auto
    grid-gap 5px
    align-items baseline

    &-title {
      font-weight: 700;
      font-size: 0.875em
      line-height: 16px;
    }

    &-line {
      height 1px
      border-bottom: 1px dashed var(--main-color-75)
    }

    &-value {
      font-size: 0.875em
      line-height: 16px;
      text-align right
    }
  }

  &__specs {
    margin-top 18px
    margin-bottom -15px
    +below(1100px) {
      column-count 2
      column-gap 30px
    }
    +below(720px) {
      column-count 1
    }
  }

  &__spec {
    display flex
    align-items center
    gap 15px
    margin-bottom 15px
    break-inside: avoid-column;

    &-icon {
      padding 20px
      flex-shrink 0
      background: var(--gray)
      border-radius 50%
      display flex

      .icon {
        width 20px
        height 20px

        path {
          stroke var(--main-color-75)
        }
      }
    }

    &-title {
      font-weight: 700;
      font-size: 0.875em
      line-height: 145%;
      margin-bottom: 5px;
      display flex
    }

    &-description {
      font-size: 0.75em
      line-height: 150%;
    }
  }
}
</style>
